import React from "react";

const CreateEmployeeDocuments = React.lazy(() =>
	import("./CreateEmployeeDocument")
);
const Index = React.lazy(() => import("./index"));
// const EmployeeDocumentsDetails = React.lazy(() =>
// 	import("./EmployeeDocumentsDetails")
// );

export const employeeDocumentsRoutes = [
	{
		path: "/admin/employeeDocuments",
		name: "Employee Documents",
		element: Index,
	},
	{
		path: "/admin/employeeDocuments/create",
		name: "Create Employee Documents",
		element: CreateEmployeeDocuments,
	},
	{
		path: "/admin/employeeDocuments/update/:id?",
		name: "Create Employee Documents",
		element: CreateEmployeeDocuments,
	},
	// {
	// 	path: "/admin/employeeDocuments/:id?",
	// 	exact: true,
	// 	name: "Employee Documents",
	// 	element:EmployeeDocumentsDetails,
	// },
];
